// keys to indentify react queries
export enum QueryKey {
  ValidateConsultationDiscount = 'validateConsultationDiscount'
}
